module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/baseball-cc710e1ec07f3e4234305a8509f24b4b.svg";